/* Alarie - rueda de fotos en abanico.
   Gira sola, despacio y sin fin. Se puede arrastrar con el raton o el dedo; al
   soltar sigue con la inercia y vuelve al ritmo normal. Se para cuando la
   seccion no esta en pantalla y mientras el raton esta encima.
   Ademas de --spin, escribe en cada foto su angulo actual (--a, entre -180 y
   180) para que el CSS la incline solo una parte y queden casi pegadas. */
(function () {
  'use strict';
  if (window.__alarieWheel) return;
  window.__alarieWheel = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function build(root) {
    if (root.dataset.wheelReady === '1') return;
    root.dataset.wheelReady = '1';

    var track = root.querySelector('.al-wheel__orbits');
    if (!track) return;
    var orbits = Array.prototype.slice.call(root.querySelectorAll('.al-wheel__orbit'));
    var step = parseFloat(root.style.getPropertyValue('--step'));
    if (isNaN(step)) step = orbits.length ? 360 / orbits.length : 18;

    var base = parseFloat(root.getAttribute('data-speed'));
    if (isNaN(base)) base = 3.2;              /* grados por segundo */
    var dir = root.getAttribute('data-dir') === 'derecha' ? 1 : -1;

    var spin = 0, vel = 0, last = 0;
    var hover = false, dragging = false, visible = false;

    function write() {
      root.style.setProperty('--spin', spin.toFixed(3));
      for (var i = 0; i < orbits.length; i++) {
        var a = i * step + spin;
        a = ((a + 180) % 360 + 360) % 360 - 180;
        orbits[i].style.setProperty('--a', a.toFixed(2));
      }
    }

    if (reduce) { write(); return; }

    function frame(t) {
      window.requestAnimationFrame(frame);
      if (!last) { last = t; return; }
      var dt = (t - last) / 1000; last = t;
      if (dt > 0.05) dt = 0.05;
      if (!visible) return;

      if (!dragging) {
        spin += (dir * base + vel) * dt; /* no se para al pasar el raton por encima */
        vel *= Math.pow(0.08, dt);           /* la inercia se apaga sola */
        if (Math.abs(vel) < 0.2) vel = 0;
      }
      if (spin > 360) spin -= 360;
      if (spin < -360) spin += 360;
      write();
    }

    /* --- arrastrar --- */
    var px = 0, pt = 0, id = null;
    var DEG_PX = 0.07;                        /* grados por pixel arrastrado */

    track.addEventListener('pointerdown', function (e) {
      dragging = true; id = e.pointerId; px = e.clientX; pt = e.timeStamp; vel = 0;
      if (track.setPointerCapture) { try { track.setPointerCapture(id); } catch (err) {} }
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== id) return;
      var dx = e.clientX - px;
      var dtms = e.timeStamp - pt;
      spin += dx * DEG_PX;
      if (dtms > 0) vel = (dx * DEG_PX) / (dtms / 1000);
      px = e.clientX; pt = e.timeStamp;
      write();
    });
    function release(e) {
      if (!dragging || (e && e.pointerId !== id)) return;
      dragging = false; id = null;
      if (vel > 260) vel = 260;
      if (vel < -260) vel = -260;
    }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('lostpointercapture', release);

    if (fine) {
      root.addEventListener('mouseenter', function () { hover = true; });
      root.addEventListener('mouseleave', function () { hover = false; });
    }

    /* --- solo gira cuando se ve --- */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible = en.isIntersecting; if (visible) last = 0; });
      }, { rootMargin: '120px 0px' }).observe(root);
    } else {
      visible = true;
    }
    var r0 = root.getBoundingClientRect();
    if (r0.top < window.innerHeight && r0.bottom > 0) visible = true;

    write();
    window.requestAnimationFrame(frame);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wheel]'), build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
